<template>
  <div class="cabo-logo-container">
    <img
      src="/favicon.png"
      alt="Cabo Party Logo"
      class="cabo-logo-img"
      :style="{ width: size + 'px', height: size + 'px' }"
    />
  </div>
</template>

<script>
export default {
  name: 'CaboLogo',
  props: {
    size: {
      type: [Number, String],
      default: 28,
    },
  },
};
</script>

<style scoped>
.cabo-logo-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cabo-logo-img {
  border-radius: 6px;
  object-fit: contain;
  box-shadow: 0 0 10px rgba(223, 183, 132, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.cabo-logo-container:hover .cabo-logo-img {
  transform: scale(1.08);
  box-shadow: 0 0 14px rgba(223, 183, 132, 0.4);
}
</style>
